<template>
    <td-dialog :title="$t(title)" :before-close="cancel" :visible.sync="dialogSendVisible" width="348px" :close-on-click-modal="false" :close-on-press-escape="false" top="18vh">
        <el-form :model="formInfo" ref="formInfo" :rules="rules" label-position="right" label-width="108px">
            <el-form-item :label="$t('common.PUSH_DEXTINATION')" prop="iPushDestination">
                <td-select
                    v-model="formInfo.iPushDestination"
                    :disabled="systemNameDisabled"
                    @change="changePushDestination"
                    :options="pushDestination"
                    :clearable="false"
                    :placeholder="$t('common.PLEASE_SELECT')"
                ></td-select>
            </el-form-item>
            <el-form-item :label="$t('common.PUSH_WAY')" prop="iPushWay" v-if="pushShow">
                <td-select v-model="formInfo.iPushWay" :options="pushWay" :placeholder="$t('common.PLEASE_SELECT')" :clearable="false"></td-select>
            </el-form-item>
            <el-form-item :label="$t('common.SYSFLG')" prop="sSystemName" v-if="pushShow">
                <td-input v-model="formInfo.sSystemName" :disabled="systemNameDisabled" maxlength="12"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.SYSURL')" prop="sPushUrl" v-if="pushShow">
                <td-input v-model="formInfo.sPushUrl" maxlength="100"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.SUBSCRIBE_GROUP_NAME')" prop="sAlarmSubscriptionId">
                <td-select
                    v-model="formInfo.sAlarmSubscriptionId"
                    :clearable="false"
                    keys="sId"
                    text="sName"
                    :options="subscribeGroupList"
                    :disabled="!isAddData"
                    :placeholder="$t('common.PLEASE_SELECT')"
                ></td-select>
            </el-form-item>
            <el-form-item :label="$t('common.DESCRIPTION')" prop="sDescribe">
                <td-input v-model="formInfo.sDescribe" type="textarea" maxlength="100"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.ENABLE')" prop="iStartStatus">
                <td-checkbox v-model="formInfo.iStartStatus"></td-checkbox>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <td-button type="primary" :loading="saveLoading" @click="submitForm('formInfo')">{{ $t('common.SAVE') }}</td-button>
            <td-button @click="cancel">{{ $t('common.CANCAL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import api from '../assets/api.js';
export default {
    props: ['title', 'dialogSendVisible', 'editItem', 'isAddData', 'pushDestination', 'systemNameDisabled'],
    created() {
        this.initSelect();
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        // 为编辑状态则进行初始化数据
        if (!this.isAddData) {
            this.changePushDestination(this.editItem.iPushDestination);
            this.initEditData();
        }
    },
    // 定义变量
    data() {
        return {
            // 表单信息
            formInfo: {
                iPushWay: this.$common.pushWay.WEB_SERVICE,
                sPushUrl: '',
                sSystemName: '',
                sDescribe: '',
                iStartStatus: false,
                iPushDestination: this.$common.pushDestination.THIRD_PARTY_SYSTEM
            },
            pushShow: true,
            saveLoading: false,
            // 推送方式
            pushWay: [
                {
                    value: this.$common.pushWay.WEB_SERVICE,
                    label: this.$t('common.WEB_SERVICE')
                }
            ],
            subscribeGroupList: [],
            // 对表单进行数据验证
            rules: {
                iPushDestination: [{ required: true, message: this.$t('error.ERROR_PUSH_DESTINATION_NULL'), trigger: 'change' }],
                iPushWay: [{ required: true, message: this.$t('error.ERROR_PUSH_WAY_NULL'), trigger: 'change' }],
                sAlarmSubscriptionId: [{ required: true, message: this.$t('error.ERROR_SUBSCRIBE_GROUP_NULL'), trigger: 'change' }],
                sPushUrl: [
                    { required: true, message: this.$t('error.ERROR_URL_NULL'), trigger: 'blur' },
                    { pattern: this.$regex.URL, message: this.$t('error.ERROR_ALARM_SEND_URL_ILLEGAL') },
                    { min: 1, max: 100, message: this.$t('error.ERROR_URL_MAX_LENGTH'), trigger: 'blur' }
                ],
                sSystemName: [
                    { required: true, message: this.$t('error.ERROR_SYSFLG_NULL'), trigger: 'blur' },
                    { min: 1, max: 12, message: this.$t('regex.PLEASE_ENTER_ACTIVE_LENGTH') },
                    { pattern: this.$regex.SYS_FLG, message: this.$t('error.ERROR_SYS_FLG_ILLEGAL') }
                ],
                sDescribe: [{ min: 1, max: 100, message: this.$t('error.ERROR_DESCRIPTION_MAX_LENGTH'), trigger: 'blur' }]
            }
        };
    },
    // 定义并实现方法体
    methods: {
        initSelect() {
            let param = {};
            param.iType = window.pangu.common.subscribeGroupType.ALARM_TYPE;
            //若为新增，则只查询出启用的分组
            if (this.isAddData) {
                param.iStartStatus = 1;
            }
            api.queryAlarmSubscribeGroup(param, response => {
                this.subscribeGroupList = response.data.content;
            });
        },
        // 推送目的地下拉列表值改变调用的方法
        changePushDestination(value) {
            if (value === this.$common.pushDestination.THIRD_PARTY_SYSTEM) {
                this.pushShow = true;
            }
        },
        // 初始化编辑数据
        initEditData() {
            this.formInfo.iPushDestination = this.editItem.iPushDestination;
            if (!this.editItem.iPushWay || this.editItem.iPushWay == 0) {
                this.formInfo.iPushWay = this.$common.pushWay.WEB_SERVICE;
            }
            this.formInfo.sSystemName = this.editItem.sSystemName;
            this.formInfo.sPushUrl = this.editItem.sPushUrl;
            this.formInfo.iStartStatus = this.editItem.iStartStatus !== 0;
            this.formInfo.sDescribe = this.editItem.sDescribe;
            this.formInfo.sAlarmSubscriptionId = this.editItem.sAlarmSubscriptionId;
        },
        // 提交数据
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.saveLoading = true;
                    let content = {
                        sId: this.isAddData ? '' : this.editItem.sId,
                        iPushDestination: this.formInfo.iPushDestination,
                        sSystemName: this.formInfo.sSystemName,
                        sThirdPartyId: this.editItem.sThirdPartyId,
                        sProducerId: this.editItem.sProducerId,
                        sConsumerId: this.editItem.sConsumerId,
                        sChannelId: this.editItem.sChannelId,
                        iPushWay: this.formInfo.iPushWay,
                        sPushUrl: this.formInfo.sPushUrl,
                        sAlarmSubscriptionId: this.formInfo.sAlarmSubscriptionId,
                        sDescribe: this.formInfo.sDescribe,
                        iStartStatus: this.formInfo.iStartStatus ? 1 : 0
                    };
                    api.saveAlarmSend(content, response => {
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('alarm/saveAlarmSend', response.data.statusMessage);
                            this.saveLoading = false;
                            return;
                        }
                        this.saveLoading = false;
                        let message = this.$t('common.ADD_SUCCESS');
                        if (!this.isAddData) {
                            message = this.$t('common.MODIFY_SUCCESS');
                        }
                        this.$message({ showClose: true, message: message, type: 'success' });
                        this.sendDialogClose();
                    });
                }
            });
        },
        // 取消
        cancel() {
            this.$emit('sendDialogClose');
            this.$refs['formInfo'].resetFields(); // 重置表单数据
        },
        // 关闭窗口之前需要调用的方法
        sendDialogClose() {
            this.cancel();
            this.$emit('submit');
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: rgb(30, 160, 255);
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
